import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import HeadingSkeleton from '@atlaskit/skeleton';

import { CardList } from '@atlassian/studio-browse-kit/ui/card-list';
import { AgentCardSkeleton } from '@atlassian/studio-browse-kit/agent-card-skeleton';

export const CardListSkeleton = ({
	count,
	showHeading = false,
	testId,
}: {
	count: number;
	showHeading?: boolean;
	testId?: string;
}): React.JSX.Element => {
	const isUplift = fg('rovo_agents_studio_browse_kit_uplift');
	const skeletonKeys = Array.from({ length: count }, (_, index) => `skeleton-card-${index}`);

	return (
		<Stack space="space.200">
			{showHeading ? (
				<Inline alignBlock="center">
					<HeadingSkeleton width={isUplift ? 160 : 80} height={20} isShimmering={!isUplift} />
				</Inline>
			) : null}
			<CardList columns={isUplift ? 4 : 3} testId={testId}>
				{skeletonKeys.map((key, index) => (
					<AgentCardSkeleton key={key} testId={testId ? `${testId}--card-${index}` : undefined} />
				))}
			</CardList>
		</Stack>
	);
};
